export default "__VITE_ASSET__BXMJ8wH$__"